import {ReelView} from '@gongxigames/framework/slot/modules/reels/ReelView';
import {Container, Graphics, Sprite} from 'pixi.js';

export abstract class IndependentReelView extends ReelView {

    protected _symbolsContainer!: Container;

    protected createReel(): void {
        this._backgroundContainer = new Sprite();
        this._symbolsContainer = new Container();
        this._symbolsContainer.addChildAt(this._backgroundContainer, 0);
        this._container.addChild(this._symbolsContainer);

        const mask = this.createMask();

        this._symbolsContainer.mask = mask;
        this._symbolsContainer.addChild(mask);

        // creating additional render-buffer of symbol from both sides of the reels
        this.iterateRows((rowIndex) => {
            const background = this.getSpriteFromPool('reelsBg');
            const symbol = this.createReelSymbol();

            symbol.init(this.getSpriteFromPool('symbols'));
            symbol.setSymbol(this._strip[this.makeNormalizedPosition(rowIndex + this._currentPosition)]);
            symbol.index = rowIndex;
            symbol.x = this._offsets.x;
            symbol.y = this._offsets.y + this.getYPositionForRow(rowIndex);

            this._symbols[this.rowIndexToSymbolIndex(rowIndex)] = symbol;

            if (background) {
                background.x = this._offsets.x;
                background.y = this._offsets.y + this.getYPositionForRow(rowIndex);
                this._backgroundContainer!.addChild(background);
            }
        });
    }

    protected createMask(): Graphics {
        const mask = new Graphics();

        mask.beginFill(0xffffff);
        mask.drawRect(0, 0, 1, 1);
        mask.endFill();
        mask.x = this._offsets.x;
        mask.y = this._offsets.y;
        mask.width = this._reelConstants.SYMBOL.width;
        mask.height = this._reelConstants.SYMBOL.height;

        return mask;
    }
}
